import React, { useState } from 'react';
import styled from "styled-components";
import '../../../../styles.css';
import { RiHomeSmile2Fill, RiHomeSmile2Line } from "react-icons/ri";
import { MdMessage, MdOutlineMessage } from "react-icons/md";
import { IoMdHelpCircle, IoMdHelpCircleOutline } from "react-icons/io";
import Home from './components/Home';
import InnerPage from './components/InnerPage';
import { useSelector } from 'react-redux';
import Help from './components/Help';
import Message from './components/Message';

const Tab = styled.span`
  font-size: 14px;
  line-height: 14px;
  border: 0;
  outline: 0;
  ${({ active }) =>
    active &&
    `opacity: 1;`}
`;
const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: rgb(255, 255, 255);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 25px;
  height: 80px;
  padding: 0px;
`;
const types = ["Home", "Message", "Help"];

function TabGroup({ 
  title,
  subtitle,
  widgetBlocks,
  activeWidget,
  setActiveWidget,
  setShowInnerPage,
  setActiveWidgetBlock,
  onFormSubmit
}) {
  const { widgetConfig, isChatFullScreen } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
    isChatFullScreen: state.messages.isChatFullScreen,
  }));

  return (
    <>
      <div className={`rcw-main-container ${isChatFullScreen ? 'rcw-main-container-full-screen' : ''}`}>
        <div 
          className={activeWidget === "Home" ? 'rcw-main-home-header' : ''}
          style={{ background: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor }}
        ></div>
        <div className='rcw-tab-container'>
          {activeWidget === "Home" ? <Home title={title} subtitle={subtitle} widgetBlocks={widgetBlocks} setShowInnerPage={setShowInnerPage} setActiveWidget={setActiveWidget} setActiveWidgetBlock={setActiveWidgetBlock} /> : activeWidget === "Message" ? <Message setActiveWidget={setActiveWidget} onFormSubmit={onFormSubmit} /> : activeWidget === "Help" ? <Help /> : ''}
          <div>
            <ButtonGroup>
              {types.map((type) => (
                <>
                  <div className='rcw-tab-button' onClick={() => setActiveWidget(type)} style={{ color: activeWidget === type && widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor !== '#ffffff' ? widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor : ' #000000', fontWeight: activeWidget === type ? 600 : '' }}>
                    {type === "Home" ? (activeWidget === type ? <RiHomeSmile2Fill /> : <RiHomeSmile2Line />) : type === "Message" ? (activeWidget === type ? <MdMessage /> : <MdOutlineMessage />) : type === "Help" ? (activeWidget === type ? <IoMdHelpCircle /> : <IoMdHelpCircleOutline />) : '' }
                    <Tab
                      key={type}
                      activeWidget={activeWidget === type}
                    >
                      {type}
                    </Tab>
                  </div>
                </>
              ))}
            </ButtonGroup>
          </div>
        </div>
      </div>
    </>
  );
}

const WidgetLayout = ({
  title,
  config,
  subtitle,
  widgetBlocks,
  activeWidget,
  setActiveWidget,
  onFormSubmit
}) => {
  const [showInnerPage, setShowInnerPage] = useState(false)
  const [activeWidgetBlock, setActiveWidgetBlock] = useState();

  return (
    <div className='rcs-main-layout'>
      {!showInnerPage ? 
      <TabGroup 
        title={title}
        subtitle={subtitle}
        widgetBlocks={widgetBlocks}
        activeWidget={activeWidget}
        setActiveWidget={setActiveWidget}
        setShowInnerPage={setShowInnerPage}
        setActiveWidgetBlock={setActiveWidgetBlock}
        onFormSubmit={onFormSubmit}
      /> : 
        <InnerPage setShowInnerPage={setShowInnerPage} activeWidgetBlock={activeWidgetBlock} />
      }
    </div>
  );
};

export default WidgetLayout;
